<template>
  <div class="ppcAddComment"
    v-if="(creative.status != 'done' && creative.comment_status == 'client' && $store.state.user.user_type == 'client') || (creative.status != 'done' && creative.comment_status == 'account' && $store.state.user.user_type != 'client')">
    <div class="newcomment">
      <div style="display: flex;
    align-items: center;
    justify-content: center;">
        <div v-for="(i, index) in pastedImage" :key="index" style="padding: 5px;position:relative">
          <button @click="deleteImg(index)"
            style="position: absolute; top:0; right: 0; background-color: #eee; transform: scale(0.5); transform-origin: top right"
            class="btn btn--close"></button>
          <img :src="i" />
        </div>
      </div>
      <textarea @paste="pasteFunction" placeholder="Add comment here..." v-model="text"></textarea>

      <div class="comment-location-buttons">
        <div>
          <button class="location-btn " :class="{ 'active': $store.state.locationMode }" @click="locationMode()">
            <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.34424 16.4219C7.92236 14.6445 4.75049 10.4062 4.75049 8C4.75049 5.10156 7.07471 2.75 10.0005 2.75C12.8989 2.75 15.2505 5.10156 15.2505 8C15.2505 10.4062 12.0513 14.6445 10.6294 16.4219C10.3013 16.832 9.67236 16.832 9.34424 16.4219ZM10.0005 9.75C10.9575 9.75 11.7505 8.98438 11.7505 8C11.7505 7.04297 10.9575 6.25 10.0005 6.25C9.01611 6.25 8.25049 7.04297 8.25049 8C8.25049 8.98438 9.01611 9.75 10.0005 9.75Z"
                fill="#334680" />
            </svg>

          </button>
          <button class="location-btn " :class="{ 'active': $store.state.drawingMode }" @click="drawingMode()">
            <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.25049 9.96875C8.25049 9.14844 8.6333 8.38281 9.28955 7.89062L15.77 3.02344C16.2622 2.64062 16.9731 2.69531 17.438 3.10547C17.9028 3.54297 17.9849 4.25391 17.6567 4.80078L13.2271 11.6367C12.8169 12.2656 12.1333 12.7031 11.395 12.8125L8.25049 9.96875ZM10.8755 13.6875C10.8755 15.3828 9.48096 16.75 7.81299 16.75H3.87549C3.3833 16.75 3.00049 16.3672 3.00049 15.875C3.00049 15.4102 3.3833 15 3.87549 15H3.98486C4.47705 15 4.80518 14.5078 4.75049 14.0156C4.75049 13.9062 4.75049 13.7969 4.75049 13.6875C4.75049 12.0469 6.03564 10.707 7.67627 10.6523L10.8481 13.4961C10.8481 13.5508 10.8755 13.6328 10.8755 13.6875Z"
                fill="#334680" />
            </svg>
          </button>
        </div>
        <button class="btn btn-blue btn-post" :class="{ 'active': text.length > 0 }" @click="addComment">
          <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.6997 0.886719C14.9185 1.02344 15.0278 1.26953 14.9458 1.51562L13.1958 13.3281C13.1685 13.5195 13.0591 13.7109 12.8677 13.793C12.7856 13.8477 12.6763 13.9023 12.5669 13.9023C12.4575 13.9023 12.3755 13.875 12.2935 13.8477L9.61377 12.6992L6.57861 14.668C6.46924 14.7227 6.33252 14.75 6.22314 14.75C6.14111 14.75 6.03174 14.7227 5.92236 14.6953C5.70361 14.5586 5.59424 14.3398 5.59424 14.0938V11.0039L1.3833 9.25391C1.16455 9.14453 1.00049 8.92578 1.00049 8.67969C0.973145 8.43359 1.10986 8.1875 1.32861 8.07812L14.0161 0.859375C14.2349 0.722656 14.5083 0.75 14.6997 0.886719ZM11.0903 4.03125L3.1333 8.54297L5.97705 9.74609L11.0903 4.03125ZM6.87939 12.8906L8.13721 12.0977L6.87939 11.5508V12.8906ZM12.0474 12.2891L13.3599 3.45703L7.23486 10.2656L12.0474 12.2891Z"
              fill="white" />
          </svg>
          post</button>

      </div>

    </div>
  </div>
</template>

<script>


export default {
  props: ['creative', 'brand'],
  data: () => ({
    name: "Commenter's Name",
    text: "",
    pastedImage: []
  }),
  
  methods: {
    locationMode() {
      this.$store.state.drawingMode = false;
      this.$store.state.x_position = -10;
      this.$store.state.Y_position = -10;
      this.$store.state.locationMode = !this.$store.state.locationMode
      this.$store.state.locationSearchMode = this.$store.state.locationMode
    },
    drawingMode() {
      this.$store.state.locationMode = false;
      this.$store.state.locationSearchMode = false
      this.$store.state.drawingMode = !this.$store.state.drawingMode;
    },
    deleteImg(idx) {
      this.pastedImage.splice(idx, 1)
    },
    pasteFunction(pasteEvent, callback) {
      var _this = this;
      if (pasteEvent.clipboardData == false) {
        if (typeof (callback) == "function") {
         
          callback(undefined);
        }
      }

      var items = pasteEvent.clipboardData.items;

      if (items == undefined) {
        if (typeof (callback) == "function") {
          callback(undefined);
         
        }
      }
      for (var i = 0; i < items.length; i++) {

        
        if (items[i].type.indexOf("image") != -1) {

          var blob = items[i].getAsFile();
         
          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function () {
            _this.pastedImage.push(reader.result);

          }
        }
      }

    },
    addComment() {
      var call = 0;
      if (this.text || this.pastedImage.length > 0) {
        var _this = this;
        _this.post('comment', {
          message: this.text,
          user_id: this.$store.state.user.id,
          creative_id: this.creative.id,
          time_position: 0,
          x_position: (_this.$store.state.locationMode) ? _this.$store.state.x_position : 0,
          y_position: (_this.$store.state.locationMode) ? _this.$store.state.y_position : 0,
        }, {}, function (resp) {
          if (_this.$store.state.drawingMode) {
            _this.post('comment_attachment', {
              data: _this.$store.state.drawingImage,
              comment_id: resp.data.result.comment.id,
              payment_cluster_id: resp.data.result.comment.payment_cluster_id
            }, {}, function () {
             
            })
          }
          _this.pastedImage.forEach((val) => {
            call++;
            _this.post('comment_attachment', {
              data: val,
              comment_id: resp.data.result.comment.id
            }, {}, function () {
              call--;
              if (call == 0) {
                if (_this.$parent.refreshBoard)
                  _this.$parent.refreshBoard();
              }
            })
          });

          _this.addLog({

            creative_id: _this.creative.id,
            payment_cluster_id: _this.creative.payment_cluster_id,
            creative_name: _this.creative.type == "image" ? _this.creative.width + 'x' + _this.creative.height : _this.creative.type,
            board_id: _this.creative.board.id,
            board_name: _this.creative.board.name,
            campaign_id: _this.creative.board.campaign_id,
            campaign_name: _this.creative.board.campaign.name,
            brand_id: _this.brand.id,
            brand_name: _this.brand.name,
            client_id: _this.brand.client.id,
            client_name: _this.brand.client.name,
            action: "New Comment",
            user_id: _this.$store.state.user.id,
            user_name: _this.$store.state.user.name
          }, function () {
            _this.refreshTimeline();
          })

          if (_this.$parent.refreshBoard) {
            _this.$parent.refreshBoard();
          }
          _this.$store.state.locationMode = false;
          _this.text = "";
          _this.pastedImage = [];
        }, function () { })
      }
    }
  }
};
</script>

<style scoped></style>
